import { useCallback, useEffect, useMemo, useState } from "react";
import { resolveApiBase } from "@cadenza/io-utils";
import {
  FREE_MODE_ENABLED,
  getSessionState,
  subscribeSession,
  upgradeToAuthed,
} from "./session.js";

const API_BASE = resolveApiBase("/api");
const isFreeModeEnabled = FREE_MODE_ENABLED;

export const useFreeModeAuth = () => {
  const [session, setSession] = useState(() => getSessionState());
  const [sheetOpen, setSheetOpen] = useState(false);
  const [mode, setMode] = useState("login");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isFreeModeEnabled) {
      return undefined;
    }

    const unsubscribe = subscribeSession(setSession);
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!isFreeModeEnabled || !session.authenticated) {
      return;
    }

    if (sheetOpen || status !== "idle" || error !== null) {
      setSheetOpen(false);
      setStatus("idle");
      setError(null);
    }
  }, [session.authenticated, sheetOpen, status, error]);

  const authFlow = useMemo(
    () => (isFreeModeEnabled ? upgradeToAuthed(API_BASE) : null),
    []
  );

  const handleSubmit = useCallback(
    (payload) => {
      if (!authFlow) {
        return;
      }

      const submit = mode === "signup" ? authFlow.signup : authFlow.login;
      setStatus("pending");
      setError(null);

      submit(payload)
        .then(() => {
          setStatus("success");
          setSheetOpen(false);
        })
        .catch((authError) => {
          setStatus("error");
          setError(authError);
        });
    },
    [authFlow, mode]
  );

  return {
    shouldRender: isFreeModeEnabled && !session.authenticated,
    sheetOpen,
    setSheetOpen,
    mode,
    setMode,
    status,
    error,
    handleSubmit,
  };
};
